/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq5a_Step21Inputs */

const zh_pricing_faq5a_step21 = /** @type {(inputs: Pricing_Faq5a_Step21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. 在「计划摘要」下，点击「取消计划」`)
};

const en_pricing_faq5a_step21 = /** @type {(inputs: Pricing_Faq5a_Step21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Under Plan Summary, click "Cancel Plan."`)
};

const es_pricing_faq5a_step21 = /** @type {(inputs: Pricing_Faq5a_Step21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. En Resumen del Plan, haz clic en "Cancelar Plan".`)
};

/**
* | output |
* | --- |
* | "2. Under Plan Summary, click \"Cancel Plan.\"" |
*
* @param {Pricing_Faq5a_Step21Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const pricing_faq5a_step21 = /** @type {((inputs?: Pricing_Faq5a_Step21Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq5a_Step21Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_faq5a_step21(inputs)
	if (locale === "en") return en_pricing_faq5a_step21(inputs)
	return es_pricing_faq5a_step21(inputs)
});
export { pricing_faq5a_step21 as "pricing_faq5A_step2" }